/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import useUserStore from '../../../store/userStore/userStore';

const partnerTypeJSON = async (): Promise<any> => {
  const partnerType = useJSONStore.getState().partnerType;
  const token = useUserStore.getState().userToken;
  const setPartnerType = useJSONStore.getState().setPartnerType;

  if (partnerType.length === 0) {
    await axios
      .request({
        method: CRUDMethods.GET,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.JSON.partnerType}`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {},
        data: {}
      })
      .then((res) => {
        setPartnerType(res.data.data);
      })
      .catch((err) => {
        return err.message;
      });
  }
};

export default partnerTypeJSON;
